import { render } from "./GlobalDiscountView.vue?vue&type=template&id=eb4bd976"
import script from "./GlobalDiscountView.vue?vue&type=script&lang=js"
export * from "./GlobalDiscountView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__